import React from 'react';
import { ContentTitle } from '../../../../components/utilities/styledComponents/ContentTitle';
import Banner from '../../../../components/Campanhas/Banner';
import HomeBox from '../../../../components/Campanhas/HomeBox';
import EasyFast from '../../../../components/Campanhas/EasyFastCampaign';
import ChooseCampaign from '../../../../components/Campanhas/ChooseCampaign';
import ReportEvolution from '../../../../components/Campanhas/ReportEvolution';

const Home = () => (
	<div className="px-12">
		<ContentTitle
			padding="15px 29px"
			lineheight="1.2em"
			fontSize="32px"
		>
			Campanhas
		</ContentTitle>
		<div style={{ padding: '33px 31px' }}>
			<div style={{ marginBottom: '25px' }}>
				<Banner hasProduct />
				<HomeBox />
				<EasyFast />
				<ChooseCampaign />
				<ReportEvolution />
			</div>
		</div>
	</div>
);

export default Home;
